export default "__VITE_ASSET__A9JxO5me__"